import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BUDGET_TABS } from '../../constants/budget';

/**
 * THE "Cost Reports | Edit Budgets" sub-nav, and the row it sits in, shared by
 * `pages/BudgetOverview.js` and `pages/BudgetCostCodes.js` (2026-10-05, owner:
 * the Cost Report's header card went, its controls moving onto this row the
 * way Edit Budgets already carries its version controls — so the two pages
 * would otherwise hold two copies of the same tabs and row).
 *
 * Rules for the row → `components/budget/CLAUDE.md` (Manage Budgets), moved there 2026-10-28.
 */
export const BUDGET_TABS_BAND = 'border-b border-gray-200 dark:border-gray-700';
export const BUDGET_TABS_ROW = 'flex flex-col md:flex-row md:flex-wrap md:items-end gap-x-4 gap-y-2';

export default function BudgetTabsNav() {
  const location = useLocation();
  return (
    <nav className="flex items-end gap-1 -mb-px shrink-0">
      {BUDGET_TABS.map(tab => {
        const isActive = location.pathname === tab.path;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
              isActive
                ? 'border-blue-600 text-blue-600 dark:border-blue-400 dark:text-blue-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
